import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IChildDetails } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

function VisaPrepFamilyStep5(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderChildDetails = () => {
    const allChildDetails: React.ReactNode[] = [];
    if (props.children && props.children.length) {
      props.children.forEach((childDetail: IChildDetails, i: number) => {
        allChildDetails.push(
          <SummaryGroup title={t('forms.visa:child', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.FAMILY_NAME}-${i}`}
              value={childDetail.familyName}
              label={t('forms.visa:familyName')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GIVEN_NAME}-${i}`}
              value={childDetail.givenName}
              label={t('forms.visa:givenName')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.DOB}-${i}`}
              value={childDetail.dob}
              label={t('forms.visa:dateOfBirth')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.NATIONALITY}-${i}`}
              value={childDetail.nationality}
              label={t('forms.visa:nationality')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GENDER}-${i}`}
              value={childDetail.gender}
              label={t('forms.visa:gender')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.PLACE_OF_BIRTH}`}
              value={childDetail.placeOfBirth}
              label={t('forms.visa:placeOfBirth')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.TRAVELLING_WITH}
              label={t('forms.visa:isThisPersonTravellingWithYou')}
              value={childDetail.travellingWith}
            />
            {isPersonTravellingWith(childDetail.travellingWith) ? (
              <>
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.HAS_UK_VISA}
                  label={t('forms.visa:childDoTheyHaveAVisaForTheUk', { i: i + 1 })}
                  value={childDetail.ukVisa}
                />
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.HAS_PASSPORT}
                  label={t('forms.visa:childDoTheyHaveAPassportOrTravel', { i: i + 1 })}
                  value={boolToYesNo(childDetail.hasPassport)}
                />
                {childDetail.hasPassport ? (
                  <SummaryRow
                    className={'visa-summary'}
                    key={VQ.PASSPORT_NUMBER}
                    value={childDetail.passportNumber}
                    label={t('forms.visa:childCurrentPassportOrTravelDocu', { i: i + 1 })}
                  />
                ) : null}
              </>
            ) : null}
          </SummaryGroup>,
        );
      });
    }
    return allChildDetails;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_DEPENDANT_CHILDREN}
        label={t('forms.visa:doYouHaveAnyDependantChildren')}
        value={boolToYesNo(props.hasDependantChildren)}
      />
      {props.hasDependantChildren ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            label={t('forms.visa:howManyDependantChildrenDoYouHav')}
            value={props.children?.length}
          />
          <Box as="ol" pl={8}>
            {renderChildDetails()}
          </Box>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.CHILDREN_LIVING_WITH_YOU}
            label={t('forms.visa:areTheseChildrenLivingWithYouCur')}
            value={boolToYesNo(props.childrenLivingWithYou)}
          />
          {props.childrenLivingWithYou === false ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_ADDRESS}
                label={t('forms.visa:contactAddress')}
                value={props.contactAddress}
              />
              <SummaryRow className={'visa-summary'} key={VQ.CONTACT_CITY} label={t('forms.visa:city')} value={props.contactCity} />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_POSTCODE}
                label={t('forms.visa:postcode')}
                value={props.contactPostcode}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_COUNTRY}
                label={t('forms.visa:country')}
                value={props.contactCountry}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_NUMBER}
                label={t('forms.visa:contactNumber')}
                value={props.contactNumber}
              />
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep5;
